import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

function themeStorageKey () {
  const user = localStorage.getItem('user_name') || 'guest'
  return 'panel_theme_' + user
}

function readUserTheme () {
  const saved = localStorage.getItem(themeStorageKey())
  if (saved === 'dark' || saved === 'light') return saved
  // first visit: follow the OS preference
  return (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'dark' : 'light'
}

function applyThemeClass (theme) {
  const root = document.documentElement
  root.classList.remove('theme-light', 'theme-dark')
  root.classList.add(theme === 'dark' ? 'theme-dark' : 'theme-light')
  root.setAttribute('data-theme', theme)
}

const initialTheme = typeof window !== 'undefined' ? readUserTheme() : 'light'
if (typeof document !== 'undefined') {
  applyThemeClass(initialTheme)
}

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  theme: initialTheme
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  closeSidebarMobile (state) {
    state.sidebarShow = 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  setTheme (state, theme) {
    const next = theme === 'dark' ? 'dark' : 'light'
    state.theme = next
    localStorage.setItem(themeStorageKey(), next)
    applyThemeClass(next)
  },
  toggleTheme (state) {
    const next = state.theme === 'dark' ? 'light' : 'dark'
    state.theme = next
    localStorage.setItem(themeStorageKey(), next)
    applyThemeClass(next)
  },
  syncThemeForUser (state) {
    const next = readUserTheme()
    state.theme = next
    applyThemeClass(next)
  }
}

export default new Vuex.Store({
  state,
  mutations
})
